import { XIcon } from '@heroicons/react/solid'
import React from 'react'
import Image from "../images/Picture5.png"
import YoutubeImage from "../images/YoutubeLogo.png"
import YouTube from 'react-youtube'
const VideoTPopup = ({ close }) => {
    const [video, setVideo] = React.useState(false)
    return (
        <div className="logoutPopup">
            {video ? <XIcon onClick={close} style={{ position: "absolute", bottom: "90%", left: "93%", width: "40px", color: "white", cursor: "pointer" }} /> : ""}
            <div className="logout_content">
                {video ? <div style={{ position: "absolute", width: "1000px" }}>
                    <YouTube
                        opts={{ width: 1100, height: 600 }}
                        videoId={video}                 // defaults -> null
                    // id={string}                       // defaults -> null
                    // className={string}                // defaults -> null
                    // containerClassName={string}       // defaults -> ''
                    // title={string}                    // defaults -> null
                    // opts={obj}                        // defaults -> { }
                    // onReady={func}                    // defaults -> noop
                    // onPlay={func}                     // defaults -> noop
                    // onPause={func}                    // defaults -> noop
                    // onEnd={func}                      // defaults -> noop
                    // onError={func}                    // defaults -> noop
                    // onStateChange={func}              // defaults -> noop
                    // onPlaybackRateChange={func}       // defaults -> noop
                    // onPlaybackQualityChange={func}    // defaults -> noop
                    /> </div> : <>
                    <img src={Image} style={{ width: "700px" }} alt='youtube'/>
                    <div className="logout_button" style={{ position: "absolute", top: "50%", display: "flex", width: "100%" }}>
                        <div className="button_container" onClick={() => setVideo("-lRPfN7NCPE")} style={{ width: "50%", cursor: "pointer" }}>
                            <XIcon onClick={close} style={{ position: "absolute", bottom: "200%", left: "190%", width: "40px", color: "red", cursor: "pointer" }} />

                            <img src={YoutubeImage} style={{ width: "200px" }} alt='youtube'/>
                            <h3>Play in English</h3>
                        </div>
                        <div className="button_container" onClick={() => setVideo("CENEFlASomo")} style={{ width: "50%", cursor: "pointer" }}>

                            <img src={YoutubeImage} style={{ width: "200px" }} alt='youtube'/>
                            <h3>Play in Hindi</h3>

                        </div>

                    </div></>
                }
            </div>
        </div>
    )
}

export default VideoTPopup